import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import styles from '../detail.module.less';

// import { forward } from "../../../service/chat-service";

import tools from '../../../utils/tools';
import ProductSelectModal from './procutSelectModal';

import targetImage from '../../../public/images/typecheck.png';

const propTypes = {
  productObj: PropTypes.shape({
    priceType: PropTypes.number,
    name: PropTypes.string,
    isRelease: PropTypes.number,
    templateType: PropTypes.number,
    specification: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    })),
  }).isRequired,
  showFormIcon: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  isOpenAccount: PropTypes.bool,
  isActive: PropTypes.bool,
};

const defaultProps = {
  isOpenAccount: false,
  isActive: false,
};

class BuyButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // isOpen: false,
      selectProduct: false,
    };
  }

  // 跳转
  jumpTo = () => {
    const { history } = this.props;
    const shareUserId = tools.getQueryString('shareUserId');
    const productId = tools.getQueryString('productId');
    let url = `/confirmorder?shareUserId=${shareUserId}&productId=${productId}`;

    const liveId = tools.getQueryString('liveId');
    if (liveId) url += `&liveId=${liveId}`;

    const streamName = tools.getQueryString('streamName');
    if (streamName) url += `&streamName=${streamName}`;

    history.push(url);
  }

  // 判断点击购买类型

  handleBuy = () => {
    const {
      productObj: { priceType },
    } = this.props;
    if (priceType === 4) {
      this.setState({ selectProduct: true });
    } else {
      this.jumpTo();
    }
  }

  // 转发领钱
  handleForward = () => {
    const { productObj, history } = this.props;
    const productId = tools.getQueryString('productId');
    const shareUserId = tools.getQueryString('shareUserId');
    const price = tools.getQueryString('price');
    history.push(
      `/rewardRule?productId=${productId}&shareUserId=${shareUserId}&price=${price}&productName=${productObj.name}`,
    );
  }

  /**
   * 组合价格购买
   * @param specificationId
   * @param buyNumber
   */
  handleBuySpecification = (specificationId) => {
    const { history } = this.props;
    const shareUserId = tools.getQueryString('shareUserId');
    const productId = tools.getQueryString('productId');

    let url = `/confirmorder?shareUserId=${shareUserId}&productId=${productId}&specificationId=${specificationId}`;

    const liveId = tools.getQueryString('liveId');
    if (liveId) url += `&liveId=${liveId}`;

    const streamName = tools.getQueryString('streamName');
    if (streamName) url += `&streamName=${streamName}`;

    history.push(url);
  }

  hideModal = () => this.setState({ selectProduct: false })

  jumpToTarget = () => {
    document.getElementById('form_submit').scrollIntoView();
  }

  ChangeRouter = () => {
    const { productObj, history } = this.props;
    const shareUserId = tools.getQueryString('shareUserId');
    const productId = tools.getQueryString('productId');
    if (productObj.isRelease === 0) {
      history.push(`/openAccount?shareUserId=${shareUserId}&productId=${productId}`);
    } else {
      Toast.show('商品已下架', 1);
    }
  }

  render() {
    const {
      productObj, showFormIcon, isOpenAccount, isActive,
    } = this.props;
    const { selectProduct } = this.state;

    if (isOpenAccount) {
      return (
        <div className={styles.footer}>
          <div className={styles.footerContent}>
            <span className={styles.btn} onClick={this.ChangeRouter} role="button" tabIndex={0}>
              注册体验
            </span>
            {isActive ? (
              <span className={styles.btn} onClick={this.handleForward} role="button" tabIndex={0}>
                转发领钱
              </span>
            ) : null}
          </div>
        </div>
      );
    }

    return (
      <div className={styles.footer}>
        {!!showFormIcon && (
          <div className={styles.jumpTargetImage} onClick={this.jumpToTarget} role="button" tabIndex={0}>
            <img src={targetImage} alt="" />
          </div>
        )}
        {productObj.templateType === 2 && (
          <div className={styles.footerContent}>
            {productObj.isRelease === 0 ? (
              <div>
                <div className={styles.btn} onClick={this.handleBuy} role="button" tabIndex={0}>
                  购买
                </div>

                {isActive ? (
                  <div className={styles.btn} onClick={this.handleForward.bind(this)} role="button" tabIndex={0}>
                    转发领钱
                  </div>
                ) : null}
              </div>
            ) : (
              productObj.templateType === 2 && <div className={styles.btnDownLine}>商品已下线</div>
            )}
          </div>
        )}
        <ProductSelectModal
          visible={selectProduct}
          specification={productObj.specification || []}
          onSubmit={this.handleBuySpecification}
          close={this.hideModal}
        />
      </div>
    );
  }
}

BuyButton.propTypes = propTypes;
BuyButton.defaultProps = defaultProps;

export default withRouter(BuyButton);
